module.exports = __webpack_public_path__ + "assets/img/00108.a283509e.png";